<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>活动领取记录</h4>
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入活动名称/编号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10" v-if="false">新增活动</el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport({
              'fpi-regex:title|string#or': searchValue,
              'fpi-regex:sid|string#or': searchValue,
              'fpi-is:smodule|string#and': 'couponPrinting',
              beanName: 'tenantLog',
              title: '活动领取记录'
            })
          "
        >
          数据导出
        </el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data">
          <el-table-column label="活动名称" width="180px" prop="title" fixed></el-table-column>
          <el-table-column prop="sid" label="优惠券编号" min-width="150px"></el-table-column>
          <el-table-column prop="content" label="描述" min-width="150px"></el-table-column>
          <el-table-column prop="createTime" label="领取时间" min-width="150px"></el-table-column>
          <el-table-column prop="opType" label="类型" min-width="150px"></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="活动信息" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="145px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="活动名称" prop="title">
          <el-input v-model="formData.title"></el-input>
        </el-form-item>
        <el-form-item label="优惠券编号" prop="code">
          <el-input v-model="formData.code"></el-input>
        </el-form-item>

        <el-form-item
          label="优惠券类型"
          :rules="{ required: true, trigger: 'blur', message: '类型不能为空' }"
          prop="scopeType"
        >
          <el-select v-model="formData.scopeType">
            <el-option
              v-for="item in options.couponType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="适用产品"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '适用产品不能为空'
          }"
          prop="scopeId"
        >
          <el-select v-model="formData.scopeId">
            <el-option
              v-for="item in ProductsList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--
          <el-form-item label="可用用户类型" prop="scopeUser">
          <el-select v-model="formData.scopeUser">
            <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        -->
        <el-form-item
          label="优惠券总数量"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券总数量不能为空'
          }"
          prop="quantity"
          v-if="!isEdit"
        >
          <el-input type="number" v-model="formData.quantity"></el-input>
        </el-form-item>

        <!-- <el-form-item label="库存剩余数量" prop="stock">
          <el-input type="number" v-model="formData.stock"></el-input>
        </el-form-item>
        -->
        <!--
        <el-form-item label="是否随产品赠送" prop="giftWithProduct">
          <el-switch
            v-model="formData.giftWithProduct"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        -->
        <el-form-item
          label="活动时间"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券总数量不能为空'
          }"
          prop="timeRange"
        >
          <el-date-picker
            v-model="formData.timeRange"
            type="datetimerange"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          ></el-date-picker>
        </el-form-item>

        <!--
        -->
        <el-form-item
          label="优惠券有效时长(天)"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券有效时长不能为空'
          }"
          prop="duration"
        >
          <el-input type="number" v-model="formData.duration"></el-input>
        </el-form-item>

        <el-form-item
          label="优惠券折扣类型"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券折扣类型不能为空'
          }"
          prop="type"
        >
          <el-select v-model="formData.type">
            <el-option
              v-for="item in options.CpsDiscountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="优惠券面值"
          :rules="{
            required: true,
            trigger: 'blur',
            message: '优惠券面值不能为空'
          }"
          prop="value"
        >
          <el-input type="number" v-model="formData.value"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="formData.description"></el-input>
        </el-form-item>

        <!--  <el-form-item label="使用条件" prop="prerequisites">
          <el-select v-model="formData.prerequisites">
            <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        -->
        <!--
        <el-form-item label="领取数量" prop="eachDelivery">
          <el-input type="number" v-model="formData.eachDelivery"></el-input>
        </el-form-item>
        -->

        <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'tenantLog',
  data() {
    return {
      name: 'tenantLog',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        timeRange: []
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_couponState: { codeId: 'couponState' },
        codecfg_couponType: { codeId: 'couponType' },
        codecfg_CpsDiscountType: { codeId: 'CpsDiscountType' }
      },
      //产品列表
      ProductsList: [],
      isEdit: false //编辑为true,新增为false
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatState(row, column, cellValue, index) {
      return this.osg.codelabel('couponState', cellValue);
    },
    formatterCouponType(row, column, cellValue, index) {
      return this.osg.codelabel('couponType', cellValue);
    },
    formatterCpsDiscountType(row, column, cellValue, index) {
      return this.osg.codelabel('CpsDiscountType', cellValue);
    },
    formatterProductsList(row, column, cellValue, index) {
      console.log(this.ProductsList);
      let label = this.ProductsList.map(item => {
        if (item.value == cellValue) {
          return item.label;
        }
      }).join('');
      return label;
    },
    getProductsData() {
      let params = {
        // page: this.fpi.page,
        // rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          if (this.$util.isJson(item.image)) {
            item.image = JSON.parse(item.image);
          }
          item.label = item.name;
          item.value = item._id;
        });
        this.ProductsList = res.data;
      });
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:title|string#or': this.searchValue,
        'regex:sid|string#or': this.searchValue,
        'is:smodule|string#and': 'couponPrinting',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('/tenantLog/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //根据网址 提示域名下拉框
    querySearch(queryString, cb) {
      let url = this.formData.website;
      let reg = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})www\.(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      if (reg.test(url)) {
        if (url.indexOf('www.') != -1) {
          url = url.substr(url.indexOf('.') + 1);
        } else if (url.indexOf('http://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
        } else if (url.indexOf('https://') != -1) {
          url = url.substr(url.indexOf('/', url.indexOf('/') + 1) + 1);
          if (url.indexOf('https://www.') != -1) {
            url = url.substr(url.indexOf('.') + 1);
          }
        }
        // 调用 callback 返回建议列表的数据
        cb([{ label: url, value: url }]);
      } else {
        cb([{}]);
      }
    },
    doNew() {
      this.doInit();
      this.isEdit = false;
      this.openDetail = true;
    },
    doEdit(row) {
      this.isEdit = true;
      var row = this.$util.deepCopy(row);
      if (row.startDate && row.endDate) row.timeRange = [row.startDate, row.endDate];
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      this.$util.saveExtField(this.extFields, this.formData);
      if (this.osg.validate()) {
        if (this.formData.timeRange) {
          this.formData.startDate = this.formData.timeRange[0];
          this.formData.endDate = this.formData.timeRange[1];
          let startDate = new Date(this.formData.timeRange[0]).getTime();
          let nowDate = new Date().valueOf();
          // 当选择的开始时间大于现在的时间，这个优惠券未激活状态
          if (startDate > nowDate) this.formData.state = 2;
          delete this.formData.timeRange;
        }
        this.formData.stock = this.formData.quantity;
        this.osg.ajax('basic/coupon/upsert.do', this.formData, res => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/coupon/enable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/coupon/disable/' + id + '.do', null, res => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        let that = this;
        that.osg.ajax(`basic/coupon/remove/${id}.do`, null, res => {
          that.osg.toast('删除成功');
          that.getData();
        });
      });
    }
  }
};
</script>
